import { Detail } from './detail.models';
import { Concepts } from './concept.models';
import { Client } from './client.models';
import { Currencie } from './currencie.models';
import { Header } from './header.models';
import { VoucherTypes } from './vouchertype.models';
import { SaleCondition } from './condicionVenta.models';
import { Tributo } from './tributo.models';

export class Voucher {
  id: number;
  type?: string;
  cae?: string;
  expirationDateCae?: string;
  netAmount?: number;
  taxableAmount?: number;
  ivaAmount?: number;
  totalAmount?: number;
  totalExemptConceptAmount?: number;
  exportAmount?: number;
  comment?: string;
  recordQuantity?: number;
  currencyQuotation?: number;
  status?: string;
  electronic?: number;
  sent?: number;
  barCode?: string;
  user?: string;
  optionals?: object;
  currencyId: number;
  headerId: number;
  detailId: number;
  conversionUnitId?: number;
  conceptId: number;
  clientId?: number;
  relatedVoucherId?: number; // Nuevo campo para comprobantes relacionados
  createdAt?: Date;
  updatedAt?: Date;
  deletedAt?: Date;
  urlReceipt?: string;
  paymentStatus?: string;

  // Relaciones
  currency: Currencie;
  header: Header;
  detail: Detail[];
  concept: Concepts;
  client?: Client;
  tributes?: Array<Tributo>;
  iva?: Array<{
    id: number;
    code?: string;
    name?: string;
    baseImp: number;
    importe: number;
  }>;
  voucherType?: VoucherTypes; // Tipo de comprobante
  associatedVouchers: any[];
  stockMovements: any[];
  relatedVoucher?: Voucher; // Nueva relación para el comprobante relacionado
  relatedBy?: Voucher[]; // Nueva relación para los comprobantes que hacen referencia a este
}
